import { apiGet, ApiCallError } from "./client.js";
import type { ScoreRunSummary } from "./product-types.js";

export async function getLatestScore(
  websiteId: string,
): Promise<ScoreRunSummary | null> {
  return apiGet<ScoreRunSummary | null>(`/websites/${websiteId}/scores`);
}

export async function getScoreById(
  websiteId: string,
  runId: string,
): Promise<ScoreRunSummary | null> {
  try {
    return await apiGet<ScoreRunSummary>(
      `/websites/${websiteId}/scores/${runId}`,
    );
  } catch (err) {
    if (err instanceof ApiCallError && err.status === 404) return null;
    throw err;
  }
}
